import React from 'react';
import banner from '../../../images/Banner-Aman-Mart-1-removebg-preview.png';
import { Button, Container } from '../../../components/ui';

export default function HeroSection() {
  return (
    <section id="home" className="relative pt-14 pb-20 md:pt-16 md:pb-56 overflow-hidden">
      {/* Background: 3 hijau lembut → putih */}
      <div className="absolute inset-0 bg-green-to-white-hero" />
      {/* Strip dekoratif: 3 hijau ke putih */}
      {/* <div className="absolute bottom-0 left-0 right-0 h-56" aria-hidden /> */}

      <div className="relative z-10 w-full">
        <Container className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Teks & CTA */}
          <div className="px-0 py-8 lg:py-12 flex flex-col justify-center order-2 lg:order-1">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-am-text-900 font-display leading-tight">
              Selamat Datang di Aman Mart
            </h1>
            <p className="mt-4 text-am-text-700 font-body text-lg max-w-lg leading-relaxed">
              Beli kebutuhan harian dengan aman, mudah, dan nyaman.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button variant="primary" size="lg">Belanja Sekarang</Button>
              <Button variant="secondary" size="lg">Pelajari Lebih Lanjut</Button>
            </div>
          </div>

          {/* Gambar + blok hijau */}
          <div className="relative flex items-center justify-center min-h-[280px] md:min-h-[320px] p-6 lg:p-8 order-1 lg:order-2">
            <div className="hidden md:block absolute right-4 lg:right-8 w-[280px] lg:w-96 h-72 lg:h-80 rounded-2xl bg-gradient-to-br from-am-accent-700 via-am-accent to-am-person-700 shadow-xl z-0 transform rotate-3" aria-hidden />
            <img
              src={banner}
              alt="Banner Aman Mart"
              className="relative max-w-[240px] sm:max-w-[280px] md:max-w-md w-full drop-shadow-lg z-10 animate-float object-contain"
            />
          </div>
        </Container>
      </div>
    </section>
  );
}
